import { CapacitorConfig } from '@capacitor/cli';
import { KeyboardResize } from '@capacitor/keyboard';

const LATEST_CAPGO_VERSION = '0.1.8';
export const MIN_ANDROID_VERSION = '1.1.0';
export const MIN_IOS_VERSION = '1.1.0';

const config: CapacitorConfig = {
  appId: 'app.pueblo.app',
  appName: 'Pueblo',
  webDir: 'www/browser',
  plugins: {
    FirebaseAuthentication: {
      skipNativeAuth: true,
      providers: ['phone'],
    },
    CapacitorUpdater: {
      appId: 'app.pueblo.app',
      version: LATEST_CAPGO_VERSION,
    },
    Keyboard: {
      resize: KeyboardResize.Body,
      resizeOnFullScreen: true,
    },
  },
  ios: {
    scheme: 'Pueblo',
  },
};

export default config;
